const CancelIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
            <g id="cancel_5_" data-name="cancel (5)" transform="translate(0 -0.001)">
                <g id="Group_185441" data-name="Group 185441" transform="translate(0 0.001)">
                    <path id="Path_76603" data-name="Path 76603"
                          d="M6.663,6l5.2-5.2A.469.469,0,0,0,11.2.138L6,5.338.8.138A.469.469,0,0,0,.137.8L5.337,6l-5.2,5.2a.469.469,0,0,0,.663.663L6,6.664l5.2,5.2a.469.469,0,0,0,.663-.663Z"
                          transform="translate(0 -0.001)" fill="#666"/>
                </g>
            </g>
        </svg>
    )
}
export default CancelIcon;
